import { cn } from "@-/com.npmjs.cn";
import { Head } from "@-/com.npmjs.expo-router/head";
import type { ReactNode } from "react";

/**
 * The root of every public website page: the website's palette and font on a full-viewport scroll
 * container (the app shell fixes the document body, so each page scrolls itself), plus the page's
 * title and description for browsers, search engines and link previews.
 */
export function WebsitePage({
  children,
  className,
  description,
  title,
}: {
  children: ReactNode;
  className?: string;
  description: string;
  title: string;
}) {
  return (
    <div
      className={cn(
        "absolute inset-0 overflow-x-hidden overflow-y-auto scroll-smooth bg-white font-website text-black antialiased",
        className,
      )}
    >
      <Head>
        <title>{title}</title>
        <meta content={description} name="description" />
        <meta content={title} property="og:title" />
        <meta content={description} property="og:description" />
      </Head>
      {children}
    </div>
  );
}
